module.exports = __webpack_public_path__ + "img/IMG_1458_L_BlackMatted_MockedUp.f92c450a.jpg";